import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function ExchangeRatesWidget({ language, exchangeRates, exchangeRatesLoading, exchangeRatesError, fetchRates }) {
  return (
    <section className="exchange-rates-section" data-testid="exchange-rates-section">
      <div className="container">
        <h2 className="section-title stats-title">
          {language === 'ar' ? 'أسعار الصرف الحية' : language === 'ru' ? 'Курсы валют' : language === 'tr' ? 'Canlı Döviz Kurları' : 'Live Exchange Rates'}
          {exchangeRates && <span className="rates-live-dot"></span>}
        </h2>
        {exchangeRatesLoading && !exchangeRates && (
          <div className="widget-loading" data-testid="exchange-rates-loading">
            <div className="widget-spinner"></div>
            <span>{language === 'ar' ? 'جاري تحميل الأسعار...' : language === 'ru' ? 'Загрузка курсов...' : language === 'tr' ? 'Kurlar yükleniyor...' : 'Loading exchange rates...'}</span>
          </div>
        )}
        {exchangeRatesError && !exchangeRates && (
          <div className="widget-error" data-testid="exchange-rates-error">
            <span>{language === 'ar' ? 'تعذر تحميل الأسعار' : language === 'ru' ? 'Не удалось загрузить курсы' : language === 'tr' ? 'Kurlar yüklenemedi' : 'Could not load exchange rates'}</span>
            <button className="widget-retry-btn" data-testid="exchange-rates-retry" onClick={fetchRates}>
              {language === 'ar' ? 'إعادة المحاولة' : language === 'ru' ? 'Повторить' : language === 'tr' ? 'Tekrar dene' : 'Retry'}
            </button>
          </div>
        )}
        {exchangeRates && (
          <>
            <div className="exchange-rates-grid">
              {exchangeRates.rates.map((rate) => (
                <div className="rate-card" key={rate.pair} data-testid={`rate-${rate.pair}`}>
                  <div className="rate-pair">
                    <span className="rate-flag">{rate.pair.startsWith('USD') ? '🇺🇸' : rate.pair.startsWith('EUR') ? '🇪🇺' : rate.pair.startsWith('GBP') ? '🇬🇧' : rate.pair.startsWith('CHF') ? '🇨🇭' : rate.pair.startsWith('SAR') ? '🇸🇦' : rate.pair.startsWith('AED') ? '🇦🇪' : rate.pair.startsWith('RUB') ? '🇷🇺' : '💱'}</span>
                    <span className="rate-name">{rate.pair}</span>
                  </div>
                  <div className="rate-values">
                    <div className="rate-buy">
                      <span className="rate-label">{language === 'ar' ? 'شراء' : language === 'ru' ? 'Покупка' : language === 'tr' ? 'Alış' : 'Buy'}</span>
                      <span className="rate-value">{rate.buy.toFixed(4)}</span>
                    </div>
                    <div className="rate-sell">
                      <span className="rate-label">{language === 'ar' ? 'بيع' : language === 'ru' ? 'Продажа' : language === 'tr' ? 'Satış' : 'Sell'}</span>
                      <span className="rate-value">{rate.sell.toFixed(4)}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <p className="rates-footer">
              <span className="rates-source">{language === 'ar' ? 'المصدر:' : language === 'ru' ? 'Источник:' : language === 'tr' ? 'Kaynak:' : 'Source:'} <a href="https://hakandoviz.com/anasayfa" target="_blank" rel="noopener noreferrer">hakandoviz.com</a></span>
              <span className="rates-updated">{language === 'ar' ? 'يتم التحديث كل 5 دقائق' : language === 'ru' ? 'Обновляется каждые 5 минут' : language === 'tr' ? 'Her 5 dakikada güncellenir' : 'Updates every 5 minutes'}</span>
            </p>
          </>
        )}
      </div>
    </section>
  );
}
